import React from "react";
import { StyleSheet, View } from "react-native";
import { Modal, Text, TouchableOpacity } from "react-native";
import { Calendar } from "react-native-calendars";
import { useAppTheme } from "../../../hooks/useAppTheme";


interface TrackerEnquiryModalProps {
  visible: boolean;
  onClose: any;
  order: string;
}

const TrackerDateModal: React.FC<TrackerEnquiryModalProps> = ({
  visible,
  onClose,
  order,
}: any) => {
  const { colors: themeColors } = useAppTheme();
  const styles = createStyles(themeColors);
  const [day, month, year] = order.split("/");
  const markedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
    2,
    "0"
  )}`;

  return (
    <Modal visible={visible} transparent animationType="slide">
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.header}>
            <Text style={styles.title}>Date: {order}</Text>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Text style={styles.closeButtonText}>✕</Text>
            </TouchableOpacity>
          </View>
          <Calendar
            current={markedDate}
            markedDates={{
              [markedDate]: {
                selected: true,
                disableTouchEvent: true,
              },
            }}
            style={styles.calendar}
            disableMonthChange={false}
            theme={{
              backgroundColor: themeColors.background,
              calendarBackground: themeColors.surface,
              textSectionTitleColor: "#7a92a5",
              selectedDayBackgroundColor: "#00bfa5",
              selectedDayTextColor: themeColors.surface,
              todayTextColor: "#ff6f61",
              dayTextColor: "#34495e",
              textDisabledColor: "#d0d0d0",
              dotColor: "#00bfa5",
              selectedDotColor: "#ff6f61",
              arrowColor: "#00bfa5",
              monthTextColor: "#2c3e50",
              indicatorColor: "#00bfa5",
              textDayFontWeight: "500",
              textMonthFontWeight: "bold",
              textDayHeaderFontWeight: "500",
              textDayFontSize: 16,
              textMonthFontSize: 18,
              textDayHeaderFontSize: 14,
            }}
          />
        </View>
      </View>
    </Modal>
  );
};

function createStyles(colors: any) {
  return StyleSheet.create({
  calendar: {
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderRadius: 12,
    height: 350,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  closeButtonText: {
    color: colors.surface,
    fontSize: 16,
  },
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: colors.surface,
    padding: 25,
    width: "76%",
    borderRadius: 10,
  },
  title: {
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 35,
  },
  detailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
  },
  column: {
    flex: 1,
  },
  label: {
    fontWeight: "bold",
    fontSize: 16,
    marginBottom: 3,
  },
  value: {
    fontSize: 16,
    marginBottom: 10,
    paddingLeft: 4,
  },
  dropdownRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  dropdownContainer: {
    flex: 1,
    marginRight: 10,
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 20,
  },
  picker: {
    borderWidth: 1.5,
    borderColor: colors.textSecondary,
    height: 40,
    backgroundColor: colors.surface,
    borderRadius: 10,
  },
  messageInput: {
    height: 100,
    borderWidth: 1.5,
    borderColor: colors.textSecondary,
    padding: 10,
    backgroundColor: colors.surface,
    marginBottom: 15,
    borderRadius: 10,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  userName: {
    fontSize: 14,
  },
  submitButton: {
    backgroundColor: colors.text,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 5,
  },
  submitText: {
    color: colors.surface,
    fontWeight: "bold",
  },
  closeButton: {
    backgroundColor: "#1E88E5",
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  buttonPrimary: { padding: 10, backgroundColor: "black", borderRadius: 5 },
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
  containerContent: {
    flexDirection: "column",
    alignSelf: "flex-start",
  },
  fab: {
    bottom: -10,
    position: "absolute",
    zIndex: 1,
  },
});
}

export default TrackerDateModal;
